export function getApiHeaders() {
  var authHeader = ''
  if (sessionStorage.getItem('jwtToken')) {
    authHeader = 'Bearer '+sessionStorage.getItem('jwtToken')
  }
  const headers = {
    'Authorization': authHeader,
    'Content-Type': 'application/json'
  }
  return headers;
}

export function handleApiResponse(res) {
  if (!res.data.message || res.data.message !== 'success') {
    alert('There was an issue updating your records. Please log out and try again.')
  }
}

export function addressToOneLine(address1, address2) {
  var returnAddress = address1;
  if (address2) {
    returnAddress+=', '+address2
  }
  return returnAddress
}

export function phoneToDisplay(phoneJson) {
  var returnPhone = ''
  const phoneObject = JSON.parse(phoneJson)
  var phone;
  for (phone in phoneObject) {
    if (phoneObject[phone].number) {
      returnPhone += formatPhoneNumber(phoneObject[phone].number) + "(" + phoneObject[phone].type + ") "
    }
  }
  return returnPhone
}

export function formatPhoneNumber(number) {
  var returnPhone = ''
  if (number) {
    returnPhone = number.substring(0, 3) + "-" + number.substring(3, 6) + "-" + number.substring(6, 10)
  }
  return returnPhone;
}

export function parsePhoneResponse(phoneData) {
  var phone = ''
  var cellphone = ''
  for (var i = 0; i < phoneData.length; i++) {
    if (phoneData[i]['type'] === 'V' && phoneData[i]['number']) {
      phone = formatPhoneNumber(phoneData[i]['number']);
    } else if (phoneData[i]['type'] === 'C' && phoneData[i]['number']) {
      cellphone = formatPhoneNumber(phoneData[i]['number']);
    }
  }
  var returnValue = {}
  returnValue['phone'] = phone
  returnValue['cellphone'] = cellphone
  return returnValue
}

export function formatTaxId(number) {
  var returnTaxId = ''
  if (number) {
    returnTaxId = number.substring(0,2) + "-" + number.substring(2,9)
  }
  return returnTaxId;
}

export function checkForCellPhone(phoneJson) {
  var hasCell = false
  const phoneObject = JSON.parse(phoneJson)
  var phone;
  for (phone in phoneObject) {
    if (phoneObject[phone].type === 'C' && phoneObject[phone].number.length > 0) {
      hasCell = true
      break
    }
  }
  return hasCell
}